import { render, staticRenderFns } from "./ContentPanel.vue?vue&type=template&id=04ab3d03"
import script from "./ContentPanel.vue?vue&type=script&lang=js"
export * from "./ContentPanel.vue?vue&type=script&lang=js"
import style0 from "./ContentPanel.vue?vue&type=style&index=0&id=04ab3d03&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports